import React from 'react';
import './Page.css';

function GuidingPrinciples() {
  return (
    <div className="page">
      <div className="page-content">
        <div className="section-heading">
          <div className="accent-line" aria-hidden="true"></div>
          <h1>Guiding Principles</h1>
        </div>
        
        <div className="principle-item">
          <h2>Invest only in high quality business</h2>
          <p>
            We seek to invest in businesses that generate high ROCE across the business cycle. Typically, such businesses are market 
            share gainers with a strong, defensible moat and a conservative, long-term oriented management team.
          </p>
        </div>

        <div className="principle-item">
          <h2>Seek margin of safety and don't overpay</h2>
          <p>
            Investing only in high quality businesses is our first line of defence. The second line of defence is to ensure that we do 
            not overpay for such businesses. Quality companies that we seek to own are usually available at a fair price only when they 
            are going through a rough patch.
          </p>
        </div>

        <div className="principle-item">
          <h2>Hold investments for long duration</h2>
          <p>
            Time is a friend of a high quality business. Hence, we try to hold our investments for a long duration, ideally forever. 
            In practice we exit our investments if the valuation becomes egregious or we realize we made a mistake in our assessment 
            of the business quality.
          </p>
        </div>

        <div className="principle-item">
          <h2>Think independent, think contrarian, triangulate extensively</h2>
          <p>
            High quality businesses are available at a fair price only when they are going through a rough patch. To take advantage 
            of these situations we need to think independently and be contrarian. It would be impossible to do this without extensive 
            triangulation with industry experts, management teams, competitors, suppliers, customers and other investors.
          </p>
        </div>

        <div className="principle-item">
          <h2>Focus on micro over macro, and bottom up over top down</h2>
          <p>
            We are fundamental, bottom up investors and focus on the microeconomic drivers of a business. We do not make investments 
            based on macro and top-down views. Our view is that as a long term investor, we should focus on what we can control and 
            understand - the quality of the business and the price we pay for it.
          </p>
        </div>

        <div className="principle-item">
          <h2>No benchmark constraints</h2>
          <p>
            We are not wired to think in benchmarks, tracking error or relative performance. A benchmark oriented approach is inconsistent 
            with our core principles. Due to our focus on quality of business, we have a natural bias towards certain sectors and away from 
            others, which may lead to significant tracking error versus any benchmark.
          </p>
        </div>

        <div className="principle-item">
          <h2>Concentrate but not too much</h2>
          <p>
            Our natural style, consistent with our investment approach, is to run a concentrated portfolio. However, we would like to 
            strike a balance between over concentrating, which requires more conviction than we can typically have, and over diversifying, 
            which dilutes the impact of our best ideas.
          </p>
        </div>

        <div className="principle-item">
          <h2>No forecasting; No projections; Think in scenarios</h2>
          <p>
            Precise and detailed modelling and forecasting is not a part of our process. We neither indulge in macro projections nor 
            engage in forecasting revenue, cash flows and EPS for the companies we evaluate. Instead, we think in terms of scenarios 
            and try to assess the probability of different outcomes.
          </p>
        </div>

        <div className="principle-item">
          <h2>Fair wage for honest work by craftsmen, not a get rich scheme</h2>
          <p>
            Our aspiration on fees and expenses is to be amongst the lowest offered by any boutique, active manager with capped AUM. 
            We do not view our enterprise in starting YK2 Partners as a "get rich" scheme. We want to build a sustainable, long-term 
            business that serves our investors well.
          </p>
        </div>

        <div className="principle-item">
          <h2>No marketing; No distributors; No bullshit</h2>
          <p>
            We believe our edge is our ability to stick to our stated strategy. We fully appreciate this is very hard. Hence we only 
            want to partner with those investors who are in sync with who we are, what we are trying to do and how we are trying to do it. 
            We do not believe in marketing or using distributors to raise capital.
          </p>
        </div>
      </div>
    </div>
  );
}

export default GuidingPrinciples;
